const collectionScope = document.querySelector('[data-collection-section]');
if (collectionScope) {
  const panel = collectionScope.querySelector('.collection-filter-panel');
  const toggles = [...collectionScope.querySelectorAll('[data-collection-filter-toggle]')];
  const mobile = matchMedia('(max-width: 749px)');
  let opener;
  function setFilters(open, trigger) {
    if (open) opener = trigger || toggles[0];
    panel.hidden = !open;
    collectionScope.classList.toggle('has-open-filters', open);
    document.body.classList.toggle('collection-filters-open', open && mobile.matches);
    toggles.forEach(button => {
      button.setAttribute('aria-expanded', String(open));
      const label = button.querySelector('[data-filter-label]');
      if (label) label.textContent = open ? 'HIDE SORT & FILTER' : 'SORT & FILTER';
    });
    if (open && mobile.matches) {
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.querySelector('[data-collection-filter-close]').focus();
    } else {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
    }
    if (!open) opener?.focus({ preventScroll: true });
  }
  toggles.forEach(button => button.addEventListener('click', () => setFilters(panel.hidden, button)));
  panel.querySelector('[data-collection-filter-close]')?.addEventListener('click', () => setFilters(false));
  collectionScope.querySelectorAll('[data-filter-shortcut]').forEach(button => button.addEventListener('click', () => {
    setFilters(true, button);
    const group = document.getElementById(button.dataset.filterShortcut);
    if (group) { group.open = true; group.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); group.querySelector('summary').focus(); }
  }));
  panel.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); setFilters(false); }
    if (event.key !== 'Tab' || !mobile.matches) return;
    const controls = [...panel.querySelectorAll('button, summary, input, select, a[href]')].filter(x => !x.disabled && x.getClientRects().length);
    const first = controls[0], last = controls.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  mobile.addEventListener('change', () => { if (!panel.hidden) setFilters(false); });
  collectionScope.querySelectorAll('[data-series-scroll]').forEach(button => button.addEventListener('click', () => {
    const rail = collectionScope.querySelector('.originals-collection-rail');
    rail.scrollBy({ left: Number(button.dataset.seriesScroll) * rail.clientWidth * .8, behavior: 'smooth' });
  }));
  collectionScope.querySelectorAll('.vanilla-personality').forEach(card => card.addEventListener('toggle', () => {
    card.querySelector('summary').setAttribute('aria-expanded', String(card.open));
    if (card.open) collectionScope.querySelectorAll('.vanilla-personality[open]').forEach(other => { if (other !== card) other.open = false; });
  }));
  const activeTab = collectionScope.querySelector('.collection-tabs [aria-current]');
  if (activeTab) activeTab.closest('.collection-tabs').scrollLeft = Math.max(0, activeTab.offsetLeft - 20);
}
